import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "single-unit"
}

import { escapeRegExp } from 'lodash'
import { PropType, computed, WritableComputedRef, ref } from 'vue'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'InputStringWithUnit',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: String,
  },
  isPrepend: {
    type: Boolean,
    default: false,
  },
  units: {
    type: Array as PropType<Array<{ label: string; value: string } | string>>,
  },
  defaultUnit: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  numberPlaceholder: {
    type: String,
    default: '',
  },
  isString: {
    type: Boolean,
    default: false,
  },
  /**
   * When this option is selected, the input box will be disabled
   */
  disabledOpt: {
    type: Object as PropType<{
      value: string | number | boolean
      label: number | string
    }>,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit }) {

const props = __props





const units = props.units?.map((unit) => {
  if (typeof unit === 'string') {
    return { label: unit, value: unit }
  }
  return {
    label: unit.label,
    value: unit.value,
  }
})

// 调整正则表达式以支持字母和数字
const strRegExp = computed(() => {
  return new RegExp(
    `^(?<numberPart>[a-zA-Z\\d]+(\\.[a-zA-Z\\d]*)?)?(?<unit>${units
      ?.map(({ value }) => value)
      .join('|')})$`,
    'i',
  )
})

const backupRegExp = computed(() => {
  return new RegExp(
    `^(?<numberPart>.*)(?<unit>${units?.map(({ value }) => value).join('|')})$`,
    'i',
  )
})

const numPartRegExp = /^[a-zA-Z\d]+(\.[a-zA-Z\d]*)?$/
const specialStatusNumPartRegExp = /^(\.|\.\d+|\d+\.)$/

const modelValueMatchReg = computed(() => {
  if (typeof props.modelValue !== 'string') {
    return undefined
  }
  return props.modelValue.match(strRegExp.value)
})

// handle chaos input
const modelValueMatchBackupReg = computed(() => {
  if (typeof props.modelValue !== 'string') {
    return undefined
  }
  return props.modelValue.match(backupRegExp.value)
})

const numPart: WritableComputedRef<string> = computed({
  get() {
    const { disabledOpt } = props
    if (disabledOpt && props.modelValue === disabledOpt.value) {
      return '0'
    }
    const { numberPart = '' } =
      modelValueMatchReg.value?.groups || modelValueMatchBackupReg.value?.groups || {}
    return numberPart.trim() || ''
  },
  set(val) {
    let value = val
    if (!numPartRegExp.test(value) && !specialStatusNumPartRegExp.test(value) && !props.isString) {
      const num = parseFloat(value)
      value = Number.isNaN(num) ? value : num.toString() // 如果是 NaN，保持原值
    } else if (numPartRegExp.test(value)) {
      value = value.toString() // 保持字符串形式
    }

    const isValidNum = value === '' || value === undefined || value === null
    if (isValidNum) {
      selectedUnit.value = unit.value
    }
    inputValue.value = !isValidNum ? value + unit.value : ''
  },
})

let selectedUnit = ref('')
const unit: WritableComputedRef<string> = computed({
  get() {
    const { disabledOpt } = props
    if (disabledOpt && props.modelValue === disabledOpt.value) {
      return disabledOpt.value
    }

    const { unit = '' } =
      modelValueMatchReg.value?.groups || modelValueMatchBackupReg.value?.groups || {}
    if (unit !== '') {
      const existingUnit = props.units?.find((item) => {
        const value = typeof item === 'string' ? item : item.value
        return new RegExp(`^${escapeRegExp(value)}$`, 'i').test(unit)
      })
      return existingUnit
        ? typeof existingUnit === 'string'
          ? existingUnit
          : existingUnit.value
        : unit
    }

    if (!props.modelValue && units && units.length > 0) {
      if (selectedUnit.value) {
        return selectedUnit.value
      }
      if (props.defaultUnit && units.some(({ value }) => value === props.defaultUnit)) {
        return props.defaultUnit
      }
      return units[0].value
    }
    return ''
  },
  set(val) {
    const { disabledOpt } = props
    if (disabledOpt) {
      if (props.modelValue === disabledOpt.value) {
        inputValue.value = `0${val}`
      } else {
        inputValue.value = val
      }
      return
    }

    if (numPart.value) {
      inputValue.value = (numPart.value || '') + val
    } else {
      selectedUnit.value = val
      inputValue.value = ''
    }
  },
})

const inputValue: WritableComputedRef<string> = computed({
  get() {
    return props.modelValue || ''
  },
  set(val) {
    emit('update:modelValue', val)
  },
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, {
    class: "input-with-unit",
    modelValue: _unref(numPart),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(numPart) ? (numPart).value = $event : null)),
    disabled: __props.disabled,
    readonly: __props.disabledOpt && _unref(unit) === __props.disabledOpt.value,
    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('change'))),
    placeholder: __props.numberPlaceholder
  }, _createSlots({ _: 2 }, [
    (__props.isPrepend)
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            (_unref(units) && _unref(units).length === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(units)[0].label), 1))
              : _createCommentVNode("", true),
            (_unref(units) && _unref(units).length > 1)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  modelValue: _unref(unit),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(unit) ? (unit).value = $event : null)),
                  disabled: __props.disabled,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change')))
                }, {
                  default: _withCtx(() => [
                    (__props.disabledOpt)
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 0,
                          value: __props.disabledOpt.value,
                          label: __props.disabledOpt.label.toString()
                        }, null, 8, ["value", "label"]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(units), ({ label, value }) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: value,
                        value: value,
                        label: label
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"]))
              : _createCommentVNode("", true)
          ])
        }
      : {
          name: "append",
          fn: _withCtx(() => [
            (_unref(units) && _unref(units).length === 1)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "single-unit"
                }, _toDisplayString(_unref(units)[0].label), 1))
              : _createCommentVNode("", true),
            (_unref(units) && _unref(units).length > 1)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  modelValue: _unref(unit),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(unit) ? (unit).value = $event : null)),
                  disabled: __props.disabled,
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change')))
                }, {
                  default: _withCtx(() => [
                    (__props.disabledOpt)
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 0,
                          value: __props.disabledOpt.value,
                          label: __props.disabledOpt.label.toString()
                        }, null, 8, ["value", "label"]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(units), ({ label, value }) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: value,
                        value: value,
                        label: label
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"]))
              : _createCommentVNode("", true)
          ])
        }
  ]), 1032, ["modelValue", "disabled", "readonly", "placeholder"]))
}
}

})